const routes = [
  {
    path: '/checkin/basemap',
    name: 'checkin-basemap',
    component: () => import('@/views/basecheckin/BaseMap.vue'),
    meta: {
      title: '科普教育基地',
      hideShare: true,
    },
  },
  {
    path: '/checkin/chinamap',
    name: 'checkin-chinamap',
    component: () => import('@/views/basecheckin/ChinaMapView.vue'),
    meta: {
      title: '全国地图',
      hideShare: true,
    },
  },
  {
    path: '/checkin/myclockin',
    name: 'checkin-myclockin',
    component: () => import('@/views/basecheckin/MyClockIn.vue'),
    meta: {
      title: '我的打卡',
      hideShare: true,
    },
  },
  {
    path: '/checkin/baselist',
    name: 'checkin-baselist',
    component: () => import('@/views/basecheckin/BaseList.vue'),
    meta: {
      title: '科普教育基地',
      hideShare: true,
    },
  },
  {
    path: '/checkin/provincelist',
    name: 'checkin-provincelist',
    component: () => import('@/views/basecheckin/components/ProvinceList.vue'),
    meta: {
      title: '科普教育基地',
      hideShare: true,
    },
  },
];
export default routes;
